import React from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
function CourseInfoTile({ course, newMessages, setNewMessages }) {
  const role = useSelector((state) => state.auth?.user?.role);
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const cls =
    useSelector((state) =>
      state.pwaData?.taught_classes?.find(
        (clsObj) => clsObj._id === params?.class_id
      )
    ) || course.class_id;
  // const handleFacultyClick = () => {
  //   dispatch({ type: SET_SELECTED_COURSE, payload: course });
  //   navigate(`/Messages/${course.course_code}/course-sections`);
  // };
  const filterNewMessagesAndNavigate = () => {
    setNewMessages((prevMsgs) => {
      return prevMsgs.filter((item) => {
        if (
          !item.classes.includes(cls._id) ||
          item.course !== course.course_id._id ||
          item.faculty !== course?.faculty_id._id
        )
          return true;
        return null;
      });
    });
    navigate(
      `/Messages/${course?.course_id?.course_code}/${cls?._id}/course-messages`
    );
  };
  return (
    <div
      className={`course-info-tile-container ${
        newMessages?.find((item) => {
          if (
            item.classes.includes(cls._id) &&
            item.course === course.course_id._id &&
            item.faculty === course?.faculty_id._id
          )
            return true;
          return null;
        }) && "show-course-tile-badge"
      }`}
      onClick={() => {
        if (location.pathname !== "/Messages") return null;
        role === "Student"
          ? filterNewMessagesAndNavigate()
          : navigate(`/Messages/${course?.course_code}/course-sections`);
      }}
    >
      <h3>{course?.course_name || course?.course_id.course_name}</h3>
      <p>{course?.faculty_name || course?.faculty_id.faculty_name}</p>
      {(role === "Student" ||
        (role === "Faculty" &&
          location.pathname.includes("course-messages"))) && (
        <p className="course-info-tile-class">
          {cls?.program} {cls?.semester} {cls?.section}
        </p>
      )}
    </div>
  );
}

export default CourseInfoTile;
